"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpWizardViewAttemptModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var use_mount_hook_1 = require("../../../api/hooks/use-mount.hook");
var classnames_1 = __importDefault(require("classnames"));
var context_1 = require("../../../api/context");
var DpModal_1 = require("../Modal/DpModal");
var DpViewAssessment_1 = require("../../Learnosity/ViewAssessment/DpViewAssessment");
var Icon_1 = require("../Icon/Icon");
var DpWWAssessmentDecorator_1 = require("../WWAssessmentDecorator/DpWWAssessmentDecorator");
var constants_1 = require("../../../api/constants");
var DpWizardViewAttemptModal_styled_1 = require("./DpWizardViewAttemptModal.styled");
var react_i18next_1 = require("react-i18next");
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var DpWizardViewAttemptModal = function (_a) {
    var attempt = _a.attempt, show = _a.show, closeModal = _a.closeModal, _b = _a.isHistoricalAssessment, isHistoricalAssessment = _b === void 0 ? false : _b;
    var _c = attempt.assessment, assessmentTemplate = _c.assessmentTemplate, items = _c.assessmentTemplate.items, assignee = attempt.assignee;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var learnosityService = (0, react_1.useContext)(context_1.ServiceContext).learnosityService;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    var _d = (0, react_1.useState)(null), signedRequest = _d[0], setSignedRequest = _d[1];
    var _e = (0, react_1.useState)(items[0]), selectedItem = _e[0], setSelectedItem = _e[1];
    var _f = (0, react_1.useState)(0), selectedItemIndex = _f[0], setSelectedItemIndex = _f[1];
    var selectedItemResponse = (0, react_1.useMemo)(function () { return attempt.responses.find(function (response) { return response.externalItemId === selectedItem.externalId; }); }, [attempt, selectedItem]);
    var itemFeedback = (0, react_1.useMemo)(function () { var _a; return (_a = attempt.getItemFeedback(selectedItem)) === null || _a === void 0 ? void 0 : _a.feedback; }, [attempt, selectedItem]);
    var getAssessmentPlayerConfiguration = (0, react_1.useMemo)(function () {
        return assessmentTemplate.isWitAndWisdom
            ? {
                annotations: true,
                regions: {
                    'top-right': [
                        {
                            type: 'notepad_button',
                        },
                    ],
                    right: [],
                    'bottom-right': [
                        {
                            type: 'next_button',
                        },
                        {
                            type: 'previous_button',
                        },
                        {
                            type: 'itemcount_element',
                        },
                    ],
                },
            }
            : {
                regions: {
                    'top-right': [],
                    right: [],
                    'bottom-right': [
                        {
                            type: 'next_button',
                        },
                        {
                            type: 'previous_button',
                        },
                        {
                            type: 'itemcount_element',
                        },
                    ],
                },
            };
    }, [assessmentTemplate]);
    /**
     * initialize
     *
     * Gets Learnosity attempt request
     */
    var initialize = (0, react_1.useCallback)(function () {
        learnosityService
            .signReviewAttemptRequest(attempt.id, undefined, 'assess', __assign({ labelBundle: {
                notepad: t('DpWizardViewAttemptModal.notepad'),
            } }, getAssessmentPlayerConfiguration), isHistoricalAssessment ? attempt.assignee.id : undefined, assessmentTemplate.curriculum)
            .then(function (signed) {
            setSignedRequest(signed);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.studentAssessment'),
                },
            });
        });
    }, [
        learnosityService,
        attempt.id,
        attempt.assignee.id,
        t,
        getAssessmentPlayerConfiguration,
        isHistoricalAssessment,
        assessmentTemplate.curriculum,
        toast,
    ]);
    (0, use_mount_hook_1.useMount)(function () {
        initialize();
    });
    var itemNavigationHandler = (0, react_1.useCallback)(function (itemIndex) {
        setSelectedItem(items[itemIndex]);
        setSelectedItemIndex(itemIndex);
    }, [setSelectedItemIndex, setSelectedItem, items]);
    // Actions
    var iconName = (0, react_1.useMemo)(function () { return (!itemFeedback ? 'comment-outline' : 'comment-fill'); }, [itemFeedback]);
    var iconClassName = (0, react_1.useMemo)(function () { return (0, classnames_1.default)({ active: itemFeedback }); }, [itemFeedback]);
    return signedRequest ? ((0, jsx_runtime_1.jsxs)(DpWizardViewAttemptModal_styled_1.StyledWizardViewAttemptModal, { show: show, onHide: closeModal, size: "xl", curriculum: (0, constants_1.getCurriculumPrefixFromCurriculum)(assessmentTemplate.curriculum), "aria-labelledby": "see-assessment-title", children: [(0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Header, { children: (0, jsx_runtime_1.jsxs)("h1", { id: "see-assessment-title", children: [assessmentTemplate.title, " ", (0, jsx_runtime_1.jsx)("span", { children: "".concat(assignee.lastName, ", ").concat(assignee.firstName) })] }) }), (0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Body, { children: attempt && ((0, jsx_runtime_1.jsx)("div", { className: "modal-container", children: (0, jsx_runtime_1.jsxs)(DpWWAssessmentDecorator_1.DpWWAssessmentDecorator, { isWitAndWisdom: assessmentTemplate.isWitAndWisdom, children: [(0, jsx_runtime_1.jsx)("div", { className: "header", children: (0, jsx_runtime_1.jsxs)("div", { className: "question-info", children: [(0, jsx_runtime_1.jsx)("span", { className: "title", children: t('DpWizardViewAttemptModal.header.title', {
                                                index: selectedItemIndex + 1,
                                            }) }), (0, jsx_runtime_1.jsx)("span", { className: "response-info", children: t('DpWizardViewAttemptModal.header.awarded', {
                                                count: selectedItemResponse.totalScore,
                                            }) })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "body", children: (0, jsx_runtime_1.jsxs)("div", { className: "attempt-container", children: [(0, jsx_runtime_1.jsx)("div", { className: "response-container", children: (0, jsx_runtime_1.jsx)(DpViewAssessment_1.DpViewAssessment, { exitHandler: closeModal, signedRequest: signedRequest, itemNavigationHandler: itemNavigationHandler }) }), (0, jsx_runtime_1.jsxs)("div", { className: "feedback-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "feedback-title", children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: iconName, className: iconClassName }), (0, jsx_runtime_1.jsx)("h4", { children: t('DpWizardViewAttemptModal.feedback') })] }), (0, jsx_runtime_1.jsx)("div", { className: "feedback-content", children: itemFeedback })] })] }) })] }) })) }), (0, jsx_runtime_1.jsx)(DpModal_1.DpModal.Footer, {})] })) : null;
};
exports.DpWizardViewAttemptModal = DpWizardViewAttemptModal;
exports.default = exports.DpWizardViewAttemptModal;
